// eslint-disable-next-line no-unused-vars
import CookieConsent from 'cookieconsent';

const cookieConsentManager = {
  options: {
    cookie: {
      domain: window.location.hostname,
    },
    container: document.getElementById('cookie-consent'),
    type: 'opt-out',
    onStatusChange: function () {
      if (this.hasConsented()) {
        cookieConsentManager.onAccept();
      }
    },
    onInitialise: function () {
      if (this.hasConsented()) {
        cookieConsentManager.onAccept();
      }
    },
    layout: 'cookie-custom-layout',
    layouts: {
      'cookie-custom-layout': `
      <div class="cookie-custom-layout">
        <div class="content">
           {{message}}
           {{link}}
        </div>
        {{compliance}}
      </div>
      `,
    },
    content: {
      message: 'This website uses cookies to improve your experience.',
      link: 'View our Privacy Policy',
      policy: '',
      href: 'https://www.inscribe.ai/privacy',
    },
    elements: {
      allow:
        '<button aria-label="allow cookies" tabindex="0" class="cc-btn cc-allow i-button primary strong md">Allow All Cookies</button>',
      deny: '<button aria-label="deny cookies" tabindex="0" class="cc-btn cc-deny i-button neutral subtle md">Decline Optional</button>',
    },
    law: {
      regionalLaw: false,
    },
    revokable: true,
  },
  init: (onAccept) => {
    cookieConsentManager.onAccept = onAccept;
    window.addEventListener('load', () => {
      !navigator.webdriver &&
        window.cookieconsent.initialise(cookieConsentManager.options);
    });
  },
  open: () => {
    const banner = document.getElementsByClassName('cc-banner');
    if (banner[0]) {
      banner[0].style.display = '';
      banner[0].classList.remove('cc-invisible');
    }
  },
};

export default cookieConsentManager;
